module.exports = __webpack_public_path__ + "img/background@3x.74890dc4.png";